<template>
    <div class="aba-produto">
        <div class="vertical-flow">
            <div class="columns">
                <div class="column">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-pacotekit-produto"
                    />
                </div>
                <div class="column is-2">
                    <vss-select
                        :id="generateId(1)"
                        :value="grupoProdutoSelected"
                        title="produto-grupo-produto"
                        :options="grupoProdutoSelect"
                        :loading="grupoLoading"
                        @input="updateGrupo"
                        @search="carregarGrupos"
                        multiple
                        searchable
                        clearable
                        :closeOnSelect="false"
                    />
                </div>
                <div class="column is-2">
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>
                <div class="column header-buttons link-company-button is-2">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        :disabled="
                            regraDesconto.tipoRegraProduto && regraDesconto.tipoRegraProduto.id == 2
                        "
                        @click="abrirModal"
                    >
                        {{ $t('adicionar') }}
                    </button>
                </div>
                <div class="column header-buttons link-company-button is-2">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        :disabled="
                            (regraDesconto.tipoRegraProduto &&
                                regraDesconto.tipoRegraProduto.id == 2) ||
                            itensSelecionados.length == 0
                        "
                        @click="abrirModalEditar"
                    >
                        {{ $t('editar') }}
                    </button>
                </div>
            </div>
            <div class="columns mt-2 mb-1">
                <div class="column is-6 has-text-centered">
                    <button class="delete-btn pl-4 pr-4" @click="confirmCleanFilters">
                        {{ $t('limpar-filtros') }}
                    </button>
                </div>
                <div class="column is-6 has-text-centered">
                    <button class="save-btn pl-4 pr-4" @click="pesquisaData">
                        {{ $t('pesquisar') }}
                    </button>
                </div>
            </div>
            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="listaRegraDescontoItem"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                    checkable
                    :checked-rows.sync="itensSelecionados"
                    :custom-is-checked="
                        (selecionados, linha) =>
                            selecionados.idVenPoliticaDescontoItem ===
                            linha.idVenPoliticaDescontoItem
                    "
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.label ? f.label : f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'descricaoVenPoliticaDescontoItem'">
                            <a @click="selectedTurnoFeriado(props.row)">
                                {{ props.row[f.key] }}
                            </a>
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <b-button
                                class="action-button"
                                :disabled="
                                    regraDesconto.tipoRegraProduto &&
                                    regraDesconto.tipoRegraProduto.id == 2
                                "
                                :type="
                                    props.row['situacao'] == 1 ? 'is-danger' : 'is-success'
                                "
                                :icon-right="
                                    props.row['situacao'] == 1 ? 'delete' : 'check'
                                "
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['situacao'] == 1 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['situacao'] == 1 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else-if="f.key == 'valor'">
                            {{
                                regraDesconto.regraCampoValor == 1
                                    ? 'R$'
                                    : '' +
                                      props.row[f.key] +
                                      (regraDesconto.regraCampoValor == 0 ? '%' : '')
                            }}
                        </div>
                        <div v-else-if="f.key == 'regrasDesconto'">
                            {{ props.row[f.key] == 0 ? $t('grupo') : $t('item') }}
                        </div>
                        <div v-else-if="f.key == 'regrasDesconto'">
                            {{ props.row[f.key] == 0 ? $t('grupo') : $t('item') }}
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
            <lateral-content v-model="showModalVincular">
                <VincularProdutoListModal
                    class="pt-4"
                    v-if="showModalVincular"
                    :regraDesconto="regraDesconto"
                    :itensSelecionados="itensSelecionados"
                    :isItemsSelecionados="isItemsSelecionados"
                    :isEditItems="isEditItems"
                    @fecharModal="fecharModal"
                />
            </lateral-content>
        </div>
    </div>
</template>

<script>
// SERVICES
import RegrasDescontoItemService from '@/services/RegrasDescontoItemService';
import RegrasDescontoService from '@/services/RegrasDescontoService';
import GrupoProdutoService from '@/services/GrupoProdutoService';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import VincularProdutoListModal from '@/components/vendas/regras-desconto/modal/VincularProdutoListModal';
import VincularGrupoListModal from '@/components/vendas/regras-desconto/modal/VincularGrupoListModal';

export default {
    components: {
        ContainerLoader,
        VincularProdutoListModal,
        VincularGrupoListModal,
    },
    data() {
        return {
            ProdutoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('PACOTE'),
            integracao: this.$store.state.user.tabelasERPWebServer.includes('PACOTEPRODUTO'),
            fields: [
                {
                    key: 'idVenPoliticaDescontoItemErp',
                    label: 'codigo',
                    width: null,
                    sortable: true,
                    sortFn: null,
                },
                { key: 'descricaoGrupo', label: 'grupo', sortable: true, sortFn: null },
                { key: 'descricaoProduto', label: 'produto', sortable: true, sortFn: null },
                { key: 'inicio', label: 'inicio-faixa', sortable: true, sortFn: null },
                { key: 'fim', label: 'fim-faixa', sortable: true, sortFn: null },
                { key: 'valor', label: 'valor', sortable: true, sortFn: null },
                {
                    key: 'descontoMaximo',
                    label: 'desconto-permitido',
                    sortable: true,
                    sortFn: null,
                },
                { key: 'regrasDesconto', label: 'regra-desconto', sortable: true, sortFn: null },
                { key: 'situacao', sortable: true, sortFn: null },
                { key: 'excluir', sortable: false, sortFn: null },
            ],
            showModalVincular: false,
            service: new RegrasDescontoItemService(this.$http, this.$router),
            regraDescontoService: new RegrasDescontoService(this.$http, this.$router),
            gruposervice: new GrupoProdutoService(this.$http, this.$router),
            itensSelecionados: [],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            isItemsSelecionados: false,
            column: 'descricao',
            order: 'asc',
            isSaving: false,
            listaRegraDescontoItem: [],
            grupoLoading: false,
            isEditItems: false,
            formaAplicarRegra: 0,
            situacaoSelected: { id: 2, label: 'todos' },
            regraDesconto: {},
            situacaoSelect: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            tipoRegraProdutoSelect: [
                { id: 0, label: 'por-produto' },
                { id: 1, label: 'por-grupo' },
                { id: 2, label: 'por-produto-grupo' },
            ],
            grupoProdutoSelect: [],
            grupoProdutoSelected: [],
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.carregarGrupos();
        this.carregarDados();
        this.carregarRegraDesconto();
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;

            const grupoProdutoFiltrado = this.grupoProdutoSelected.map((item) => {
                return item.id;
            });

            this.service
                .findAll(
                    this.$route.params.id,
                    grupoProdutoFiltrado,
                    this.situacaoSelected.id,
                    this.sortTable,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((listaRegraDescontoItem) => {
                    this.listaRegraDescontoItem = listaRegraDescontoItem;
                    this.isEmpty = this.listaRegraDescontoItem.length <= 0;
                    this.isItemsSelecionados = this.listaRegraDescontoItem.length > 0;
                })
                .catch((e) => {
                    console.error('Erro ao carregar Resgra de desconto.', e);
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-carregar-regra-desconto');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        fecharModal() {
            this.showModalVincular = false;
            this.carregarDados();
            this.carregarRegraDesconto();
        },
        carregarRegraDesconto() {
            this.regraDescontoService
                .find(this.$route.params.id)
                .then((obj) => {
                    this.regraDesconto = obj.content;
                    this.regraDesconto.tipoRegraProduto = this.tipoRegraProdutoSelect[
                        this.regraDesconto.tipoRegraProduto
                    ];
                })
                .catch((e) => {
                    console.error('Erro ao carregar Resgra de desconto.', e);
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-carregar-regra-desconto');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        sortTable(field, order) {
            this.sort.column = field;
            this.sort.order = order;
            this.carregarDados(1);
        },
        abrirModal() {
            this.isEditItems = false;
            this.showModalVincular = true;
        },
        abrirModalEditar() {
            this.isEditItems = true;
            this.showModalVincular = true;
        },
        carregarGrupos(search = '') {
            this.grupoLoading = true;
            this.gruposervice
                .findAllCombo(search)
                .then((body) => {
                    this.grupoProdutoSelect = body.content.map((r) => {
                        return {
                            id: r.idgrupoproduto,
                            label: r.descricao,
                        };
                    });
                }, 350)
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de grupo: ${e}]`);
                })
                .finally((_) => {
                    this.grupoLoading = false;
                });
        },
        pesquisaData() {
            this.carregarDados();
        },
        updateGrupo(grupoSelected) {
            this.grupoProdutoSelected = grupoSelected;
        },
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        confirmCleanFilters() {
            this.$root.confirm({
                message: this.$t('msg-confirm-limpar-filtros'),
                onConfirm: this.limparFiltros,
            });
        },
        limparFiltros() {},
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idVenPoliticaDescontoItem: m.idVenPoliticaDescontoItem,
                    idVenPoliticaDescontoItemErp: m.idVenPoliticaDescontoItemErp,
                    descricaoGrupo: m.descricaoGrupo,
                    descricaoProduto: m.descricaoProduto,
                    inicio: m.inicio,
                    idGrupoProduto: m.idGrupoProduto,
                    idProduto: m.idProduto,
                    fim: m.fim,
                    valor: m.valor,
                    decontoMaximo: m.decontoMaximo,
                    regrasDesconto: m.regrasDesconto,
                    situacao: m.situacao,
                };
            });
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onGrupoProdutoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['descricaoProduto'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacao,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        updateSituacao() {
            let tempFailure = this.$t(
                    this.delete.situacao == 1 
                        ? 'msg-erro-ao-reativar-n' 
                        : 'msg-erro-ao-desativar-n', 
                    { n: this.$t('regra-desconto') }
                );
            let venPoliticaDescontoItem = {
                idVenPoliticaDescontoItem: this.delete.idVenPoliticaDescontoItem,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;
            this.service
                .updateSituacao(venPoliticaDescontoItem)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess = this.$t(
                                r.content.situacao == 1
                                    ? 'msg-sucesso-ao-reativar-n'
                                    : 'msg-sucesso-ao-desativar-n', 
                                { n: this.$t('regra-desconto') }
                            );
                        this.$root.showMessage('success', tempSuccess, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-produto {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
